import React, { useEffect } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { getPartners } from '../actions/partners';

type PropsPartners = {
  tag?: any;
  id?: number;
  isForm?: boolean;
  setCurrentTagId?: any;
  isSelected?: any;
  onClick?: (event: any) => void;
};

const Partners: React.FC<PropsPartners> = ({ isSelected, isForm = false, tag, onClick }) => {

  const dispatch = useDispatch();

  const partners = useSelector((state: any) => state.partners)
  
  useEffect(() => {
    dispatch(getPartners())
  }, [dispatch])
  
  return (
    <div className="_flex _flex-col _justify-center _items-start _mx-sm">
      <h1 className="_my-sm">Partenaires</h1>
      <p>Ils contribuent au succès de notre projet :</p>
      <div className="_flex _flex-wrap">
          {partners.map((partner, i) => (
            <a rel="noreferrer" target="_blank" href={partner.link}>
              <div className="_flex _flex-col _items-center">
                <div className="_mr-xs _mt-xs _bg-white _shadow-md _bg-no-repeat _bg-contain _bg-center _rounded-md" style={{ height: '100px', width: '100px', backgroundImage: `url(${partner.image})` }}>
                </div>
                <span className="_mt-xxs _mr-xs">
                  {partner.title}
                </span>
              </div>
            </a>
          ))}
      </div>
    </div>
  );
};

export default Partners;
